const app = angular.module('msi.addresses', [
  require('@ordergroove/brandy/src/app/utils'),
  require('@ordergroove/brandy/src/app/core/constants'),
  'ngMessages'
]);

app.component('ogShippingDropdown', require('./shipping-dropdown/shipping.dropdown'));
app.component('ogAddress', require('./address/address'));
app.component('ogAddressForm', require('./address-form/address-form'));


module.exports = app.name;
